var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9542 17.7617H13.6953V11.4819C13.6953 9.60969 12.9445 8.46296 11.8524 7.35522C11.1244 6.62194 9.91103 5.95886 8.61423 5.59221L8.38672 3.7668H12.1558V0.607422H13.6498V3.7668H17.4416L16.1903 16.6227C16.1145 17.2624 15.5912 17.7617 14.9542 17.7617ZM0.757812 16.209V16.9813C0.757812 17.4103 1.09908 17.7614 1.52376 17.7614H11.3901C11.8148 17.7614 12.156 17.4103 12.156 16.9813V16.209H0.757812ZM12.156 11.5204C12.156 5.27966 0.757812 5.27966 0.757812 11.5204H12.156ZM12.1479 13.0898H0.772461V14.65H12.1479V13.0898Z",
    fill: "#0075CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.2f875e15af1beafa4d8d79848e40157a.svg";
export { ForwardRef as ReactComponent };